<template>
  <div>
    <v-header></v-header>

    <div class="container" style="padding-top: 60px;">
      <div class="banner">
        <img src="../../static/img/home_carouse.png" alt="" />
         <h2 class="item-title"><span class="ch">校园一脸通消费系统</span> <span class="eg">
                                在线充值，校园免密支付，刷脸消费，即刷即付</span></h2>
        <!-- <div class="box">
          <span style="font-size: 28px;">智慧班牌</span>
          <span style="margin-top: 10px;">为老师和学生提供便捷的师生交流及校园服务平台</span>
          <router-link to="/applyfortrial"><input type="button" value="申请试用" /></router-link>
        </div> -->
      </div>
      <!-- <div class="introduction">
        <h2 class="item-title"><span class="eg">PRODUCT INTRODUCTION</span> <span class="ch">产品简介</span></h2>
        <p class="product-introduction">通过智慧班牌设备和后台班牌考勤管理软件的统一管理，在智慧班牌上，将实现班牌展示、学生上课刷卡考勤、考勤状况汇总展示、课表展示、班级风采展示、校园通知展示、班级文化图片展示等多种功能，对学校德育工作、减负工作均起到积极有效的作用。</p>
      </div> -->
      <div class="class-attendance">
        <h2 class="item-title">
         
          <p class="eg">
             <img src="../../static/img/ju-left.png" alt="" class="leftphoto">
            产品优势
             <img src="../../static/img/ju-right.png" alt="" class="leftphoto">
            </p> 
          <!-- <span class="ch">班级考勤功能模块</span> -->
         
        </h2>
        <div class="item-pro">
          <dl >
            <dt >
              <img src="../../static/img/classcard-one.png">
            </dt>
            <dd >
                <p class="title">家长在线充值/查询消费记录</p>
               <p class="note">家长直接微信、支付宝给孩子一卡通充值，查看余额，历史充值记录，查看孩子在校消费记录</p>
            </dd>
          </dl>
        
          <dl >
            <dd >
               <p class="title" style="margin-top:11px">学生刷脸消费</p>
               <p class="note">学生刷脸消费自助点餐刷脸毫秒识别，自动扣费提高就餐速度及效率</p>
            </dd>
            <dt >
              <img src="../../static/img/classcard-two.png">
            </dt>
            
          </dl>
          <dl >
            <dt >
              <img src="../../static/img/classcard-three.png">
            </dt>
            <dd >
              <p class="title" style="margin-top:15px">学生消费场景全覆盖</p>
               <p class="note">涵盖校园超市、食堂、打电话、医务室、洗浴等消费场景全覆盖</p>
            </dd>
          </dl>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
      return {

      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    methods: {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .header{
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .main{
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    overflow-y: auto
  }

  .footer{
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .text-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .moreline-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2
  }

  .clearfix[data-v-017dffa4]:after {
    content: "";
    height: 0;
    width: 0;
    display: block;
    clear: both
  }

  .item-title{
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .item-title .eg{
    font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
line-height:21px;
  }
.leftphoto{
  width: 24px;
  height: 24px;
  margin: 5px 13px;
  display: inline-block;
}
  .item-title .ch{
    font-size: 18px;
    font-weight: 700
  }

  .product-introduction{
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px
  }

  .button{
    background: transparent;
    border: 1px solid #ff9a00;
    color: #ff9a00
  }

  .banner{
    width: 100%;
    color: #fff;
    position: relative
  }

  .banner img{
    width: 100%
  }

  .banner input[type=button]{
    width: 100px;
    height: 40px;
    background: #ff9a00;
    color: #fff;
    border-radius: 20px;
    font-size: 14px;
    margin-top: 20px
  }

  .banner .box{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    margin-left: 43px;
    -ms-flex-direction: column;
    flex-direction: column
  }
.banner .item-title {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .banner .item-title .ch {
   font-size:40px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
  }

  .banner .item-title .eg {
    font-size:22px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:34px;
margin-top: 10px;


width:380px;

  }
  .introduction{
    padding: 100px 0
  }

  .class-attendance{
    padding: 100px 0;
    background: #f9f9f9
  }

  .class-attendance .item-pro{
    /* padding: 0 10%; */
    width: 95%;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    /* -ms-flex-wrap: wrap;
    flex-wrap: wrap; */
    box-sizing: border-box;
    padding-top: 40px;
    margin: 0 auto;
  }

  .class-attendance .item-pro dl{
    width: 100%;
    margin-top: 60px;
    display: flex;
    flex-direction: row;
  }

  .class-attendance .item-pro dt{
    width: 100%;
    display: -ms-flexbox;
    
    -ms-flex-pack: center;
    justify-content: center
  }

  .class-attendance .item-pro dt img{
    width: 340px;
    height: 260px
  }

  .class-attendance .item-pro dd{
    width: 94%;
    /* text-align: center; */
    margin: 12px 15px 0
  }

  .class-attendance .item-pro dd .title{
    font-size:30px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
/* line-height:45px; */
/* margin: 25px 0; */
  }

  .class-attendance .item-pro dd .note{
    font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
/* line-height:36px; */
margin: 20px 0; 
  }[data-v-6776eb1c] {
     -webkit-overflow-scrolling: touch;
     margin: 0;
     padding: 0
   }
</style>



// WEBPACK FOOTER //
// src/components/classcard.vue